// ---------------------------------------------------------------------------
// Estados de venta que NO representan un ingreso.
//
// Vive en su propio módulo, sin dependencias, porque estaba duplicado en
// flujoFondos.js y saleAnnulment.js y los dos Sets divergieron: se agregó
// 'cobro_en_revision' solo en uno, y el guard de idempotencia de la anulación
// dejó pasar una venta en revisión -> restoreSaleStock reintegró stock que la
// venta nunca había descontado, inflando el inventario.
//
// Una sola definición, importada por los dos.
// ---------------------------------------------------------------------------

/**
 * Incluye todas las variantes usadas históricamente por los módulos
 * (incluida 'canceled' con una L).
 */
export const CANCELLED_SALE_STATUSES = new Set([
  'anulada',
  'anulado',
  'annulled',
  'cancelled',
  'cancelado',
  'canceled',
  // Cobro con pasarela que no se pudo cancelar con certeza en la terminal. La
  // venta se conserva para verificarla a mano, pero no descontó stock ni asentó
  // caja/diario, así que no es ingreso ni tiene nada que revertir.
  // Ver src/utils/mpPoint.js -> SALE_STATUS_REVISION.
  'cobro_en_revision',
]);

export const CANCELLED_PURCHASE_STATUSES = new Set([
  'anulado',
  'anulada',
  'annulled',
  'cancelled',
  'cancelado',
]);
